const isCartPage = window.Convermax.helpers?.trimEndSlash(window.location.pathname) === '/cart.php';
const isMiniCartOpen = !!window.document.querySelector('#cart-preview-dropdown');

let currentVehicleKey = null;

const getVehicleLabelHtml = (vehicle) => {
  if (!vehicle || !Object.keys(vehicle).length) {
    return '';
  }

  const vehicleString = Object.values(vehicle).join(' ');

  return `<a class="cm_vehicle-name"
      onclick="window.Convermax.openVehicleDialog(); return false;">
      ${vehicleString}
    </a>`;
};

const getSelectedVehicleHtml = (vehicle, fits) => {
  const icon =
    fits === 'yes'
      ? `<span class="material-symbols-outlined">check_circle</span>`
      : `<span class="material-symbols-outlined cancel">cancel</span>`;

  return `
    <span class="cm_fitment-label-container">
      ${icon}
      ${fits === 'yes' ? 'Fits your' : 'Does not fit your'}
    </span>
    ${getVehicleLabelHtml(vehicle)}
  `;
};

const getOtherCompatibleVehiclesHtml = (vehicles) => {
  if (!vehicles.length) {
    return '';
  }

  return `
    <div class="cm_other-fitment">
      <span class="cm_fitment-label-container">
        <span class="material-symbols-outlined">check_circle</span>
        Fits other vehicles in your garage
      </span>
      <div class="cm_other-fitment-vehicles">
        ${vehicles.map(getVehicleLabelHtml).join('')}
      </div>
    </div>
  `;
};

const hideCartVerifyFitmentLabels = () => {
  document
    .querySelectorAll('.cm_verify-fitment-label-container')
    .forEach((label) => (label.style.display = 'none'));
};

const getOtherVehicles = (vehicle) => {
  const allVehicles = window.Convermax.getVehicleList() || [];
  return allVehicles.filter((v) => JSON.stringify(v) !== JSON.stringify(vehicle));
};

const getCompatibleVehicles = async (productId, otherVehicles) => {
  const results = await Promise.all(
    otherVehicles.map((v) => window.Convermax.verifyFitmentAsync(productId, v)),
  );
  return otherVehicles.filter((_, i) => results[i] === 'yes');
};

const updateCartVerifyFitmentLabels = async (selectedVehicle) => {
  const vehicleKey = JSON.stringify(selectedVehicle); // only update when current vehicle hasn't changed
  if (vehicleKey === currentVehicleKey) {
    return;
  }

  currentVehicleKey = vehicleKey;

  const otherVehicles = getOtherVehicles(selectedVehicle);

  const cartItems = window.document.querySelectorAll(`.cm_verify-fitment-label-container`);
  if (cartItems.length > 0) {
    for (const containerElem of cartItems) {
      try {
        const productId = containerElem.id.replace('cm_verify-fitment-label-container-', '');
        const fits = await window.Convermax.verifyFitmentAsync(productId, selectedVehicle);

        const otherCompatibleVehicles = await getCompatibleVehicles(productId, otherVehicles);

        const selectedVehicleHtml = getSelectedVehicleHtml(selectedVehicle, fits);
        const otherVehiclesHtml = getOtherCompatibleVehiclesHtml(otherCompatibleVehicles);

        const html = selectedVehicleHtml + otherVehiclesHtml;
        if (html) {
          containerElem.innerHTML = html;
          containerElem.style.display = 'flex';
        }
      } catch {
        hideCartVerifyFitmentLabels();
      }
    }
  }
};

export const onVehicleDiscarded = () => {
  currentVehicleKey = null;
  if (isCartPage || isMiniCartOpen) {
    hideCartVerifyFitmentLabels();
  }
};

export const onVehicleSelected = (vehicle) => {
  if ((isCartPage || isMiniCartOpen) && Object.keys(vehicle).length > 0) {
    updateCartVerifyFitmentLabels(vehicle);
  }
};

export const AfterInit = () => {
  const vehicle = window.Convermax.getVehicle();
  onVehicleSelected(vehicle);
};
